//import Libraries
import React, { Component } from 'react';
// import { SMController, SMScene } from 'react-scrollmagic';

//import Components
import ScrollImage from './ScrollImage/ScrollImage';
import ScrollCards from './ScrollCards/ScrollCards';
import Title from './Title/Title';
import ScrollDown from './ScrollDown/ScrollDown';
import animation from './animation'

//import Style classes
import './ScrollSection.css';


class ScrollSection extends Component{
    constructor(props){
        super(props);
        this.state = {};
    }
    componentDidMount(){
        animation();
    }
    render(){
        return (
                <div className='ScrollSection'>
                    <Title universal={this.props.universal}/>
                    <ScrollDown universal={this.props.universal}/>
                    <ScrollCards universal={this.props.universal}/>
                    {/* <div className="ScrollGradient"></div> */}
                    <div className='ScrollWrapper'>
                        <div className="ScrollGradient"></div>
                        <ScrollImage layerNumber={"1"} />
                        <ScrollImage layerNumber={["3", "3-1", "3-2", "3-3", "3-4"]} />
                        <ScrollImage layerNumber={["2", "2-1"]} />
                        <ScrollImage layerNumber={["4", "4-1"]} />
                    </div>
                </div>
        );
    }
    // this.props.universal
}

export default ScrollSection;


// WEBPACK FOOTER //
// ./src/pages/Home/ScrollSection/ScrollSection.js